/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Note
 */
export enum EnquiryCrmTaskHistoryType {
  Note = 1,
}
